import FunctionCategory from 'notebook/tables/excess/FunctionCategory';
import {EvaluablePrimitiveSpreadsheetFunction} from 'notebook/tables/excess/FunctionConstants';

export default {
  name: 'PI',
  category: FunctionCategory.MATH,
  shortDescription: 'The value of Pi.',
  description: 'Returns the value of Pi, approximately 3.14159265358979.',
  params: [],
  eval: (): number => Math.PI,
} satisfies EvaluablePrimitiveSpreadsheetFunction;
